"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currenciesOptions = exports.CurrencySelectorComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var currenciesOptions = [
    { value: "ZAR", label: "🇿🇦 ZAR" },
    { value: "USD", label: "🇺🇸 USD" },
    { value: "EUR", label: "🇪🇺 EUR" },
    { value: "INR", label: "🇮🇳 INR" },
    { value: "GBP", label: "🇬🇧 GBP" },
    { value: "GHS", label: "🇬🇭 GHS" },
    { value: "IDR", label: "🇮🇩 IDR" },
    { value: "JMD", label: "🇯🇲 JMD" },
    { value: "JPY", label: "🇯🇵 JPY" },
    { value: "MKD", label: "🇲🇰 MKD" },
    { value: "PHP", label: "🇵🇭 PHP" },
    { value: "PLN", label: "🇵🇱 PLN" },
    { value: "MYR", label: "🇲🇾 MYR" },
    { value: "RUB", label: "🇷🇺 RUB" },
    { value: "SGD", label: "🇸🇬 SGD" },
    { value: "CHF", label: "🇨🇭 CHF" },
    { value: "TWD", label: "🇹🇼 TWD" },
    { value: "THB", label: "🇹🇭 THB" },
    { value: "TRY", label: "🇹🇷 TRY" },
    { value: "AED", label: "🇦🇪 AED" },
    { value: "UAH", label: "🇺🇦 UAH" },
    { value: "VND", label: "🇻🇳 VND" },
    { value: "AUD", label: "🇦🇺 AUD" },
    { value: "NAD", label: "🇳🇦 NAD" },
];
exports.currenciesOptions = currenciesOptions;
var CurrencySelectorComponent = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b;
    return ((0, jsx_runtime_1.jsxs)(react_1.Select, { value: value, onChange: function (key) { return onChange(key); }, isDisabled: isDisabled, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: label }), (0, jsx_runtime_1.jsxs)(react_1.Select.Trigger, { children: [(0, jsx_runtime_1.jsx)(react_1.Select.Value, {}), (0, jsx_runtime_1.jsx)(react_1.Select.Indicator, {})] }), (0, jsx_runtime_1.jsx)(react_1.Select.Popover, { children: (0, jsx_runtime_1.jsx)(react_1.ListBox, { items: currenciesOptions, children: function (option) { return ((0, jsx_runtime_1.jsxs)(react_1.ListBox.Item, { id: option.value, textValue: option.label, children: [option.label, (0, jsx_runtime_1.jsx)(react_1.ListBox.ItemIndicator, {})] })); } }) })] }));
};
exports.CurrencySelectorComponent = CurrencySelectorComponent;
